import { Checkbox, IconButton, Stack } from "@mui/material";
import { CustomTextView } from "../../../component/CustomTextView";
import { useTranslation } from "react-i18next";
import {
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_WHITE,
} from "../../../../data/colors/Colors";
import { useEffect, useState } from "react";
import { STORAGE_KEYS } from "../../../../data/constant/Constants";
import SharedPreferences from "../../../../core/utils/SharedPreferences";
import { CustomButtonView } from "../../../component/CustomButtonView";
import { CloseRounded } from "@mui/icons-material";
import { Player, SchoolType } from "../../../../domain/model/User";

export function ShowRulesDialog({
  player,
  onClose,
  onConfirm,
}: {
  player: Player;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const { t } = useTranslation();
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  useEffect(() => {
    SharedPreferences.setBoolean(STORAGE_KEYS.SHOW_GAME_RULES, !doNotShowAgain);
  }, [doNotShowAgain]);

  const rules = [
    "rule_1",
    player.schoolType == SchoolType.PRIMARY
      ? "rule_2_primary"
      : player.schoolType == SchoolType.MIDDLE_AND_HIGH_SCHOOL
        ? "rule_2_secondary"
        : "",
    "rule_3",
    "rule_4",
    "rule_5",
  ];
  return (
    <Stack gap={2} p={2}>
      <Stack
        direction={"row"}
        width={"100%"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <CustomTextView text={t("game_rules")} fontWeight="bold" variant="h5" />
        <IconButton onClick={onClose} sx={{ background: COLOR_MAIN }}>
          <CloseRounded sx={{ color: COLOR_WHITE }} />
        </IconButton>
      </Stack>
      <Stack gap={1}>
        {rules.map((rule, index) => {
          return (
            <Stack direction={"row"} gap={0.5} key={index}>
              <CustomTextView
                text={`#${index + 1}`}
                textColor={COLOR_LIGHT_GRAY}
                variant="body2"
              />
              <CustomTextView text={t(rule)} fontWeight="600" variant="body2" />
            </Stack>
          );
        })}
      </Stack>
      <Stack
        direction={"row"}
        alignItems={"center"}
        width={"100%"}
        justifyContent={"space-between"}
      >
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <Checkbox
            checked={doNotShowAgain}
            onChange={(e, checked) => {
              setDoNotShowAgain(checked);
            }}
          />
          <CustomTextView text={t("do_not_show_again")} variant="body2" />
        </Stack>
        <CustomButtonView text={t("confirm")} onClick={onConfirm} />
      </Stack>
    </Stack>
  );
}
